import { Component, OnInit } from '@angular/core';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { DeviceAccount, UnmatchedDevice } from '@app/modules/smart-devices/data/smart-devices.interface';
import { NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { SmartDevicesService } from '../../service/smart-devices.service';

@Component({
  standalone: false,
  selector: 'device-setup',
  templateUrl: 'device-setup.component.html',
  styleUrls: ['device-setup.component.scss'],
})
export class DeviceSetupComponent implements OnInit {
  connectedAccounts$;

  unmatchedDevices$;

  loadingConnectionUrl = false;

  hasWriteAccess$ = this.permissionsService.hasAccessTo(Features.PERM_SMARTLOCKS_DASHBOARD_WRITE);

  constructor(
    private smartService: SmartDevicesService,
    private toast: ToastNotificationsService,
    private permissionsService: UserPermissionsService
  ) {}

  ngOnInit() {
    this.hydrateConnectedAccounts();
    this.hydrateUnmatchedDevices();
  }

  hydrateConnectedAccounts() {
    this.connectedAccounts$ = this.smartService.getConnectedAccounts().pipe(
      map((res) => ({ data: res, loading: false, error: false })),
      startWith({ data: null, loading: true, error: false }),
      catchError((e) => of({ data: null, loading: false, error: 'Error fetching accounts' }))
    );
  }

  hydrateUnmatchedDevices() {
    this.unmatchedDevices$ = this.smartService.getUnmatchedDevices().pipe(
      map((res) => ({ data: res, loading: false, error: false })),
      startWith({ data: null, loading: true, error: false }),
      catchError((e) => of({ data: null, loading: false, error: 'Error fetching devices' }))
    );
  }

  onConnectDeviceAccountClicked() {
    this.loadingConnectionUrl = true;

    this.smartService.connectDeviceAccount().subscribe((res) => {
      if (res) {
        const connectionUrl = res;
        this.loadingConnectionUrl = false;

        window.location.href = connectionUrl;
      } else {
        this.toast.open('Unable to connect a device account at this time', 'OK', NotificationType.Error);
      }
    });
  }

  onAccountDeleted(device: DeviceAccount) {
    this.hydrateConnectedAccounts();
    this.hydrateUnmatchedDevices();
  }

  onDeviceMatched(event: UnmatchedDevice) {
    this.hydrateUnmatchedDevices();
  }
}
